import { render } from "./ContactNotifPicker.vue?vue&type=template&id=19d20459&scoped=true"
import script from "./ContactNotifPicker.vue?vue&type=script&lang=ts"
export * from "./ContactNotifPicker.vue?vue&type=script&lang=ts"

import "./ContactNotifPicker.vue?vue&type=style&index=0&id=19d20459&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19d20459"

export default script